// src/router/config.ts
const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
  },
  {
    path: "/capture/:uuid",
    exact: true,
    component: "CaptureView",
    noLayout: true,
  },
  // Stories/Blog routes
  {
    path: "/stories",
    exact: true,
    component: "Stories",
  },
  {
    path: "/stories/:slug",
    exact: true,
    component: "StoryDetail",
  },
  // Legal document routes - single dynamic route for all documents
  {
    path: [
      "/privacy-CN",
      "/privacy-EN", 
      "/Terms-And-Conditions-CN",
      "/Terms-And-Conditions-EN",
      "/User-Content-License-Agreement-CN",
      "/User-Content-License-Agreement-EN"
    ],
    exact: true,
    component: "LegalDocument",
  },
  // Explore route — public capture feed
  {
    path: "/explore",
    exact: true,
    component: "Explore",
    noLayout: true,
  },
  // Public user profile
  {
    path: "/user/:handle",
    exact: true,
    component: "UserProfile",
    noLayout: true,
  },
  // Profile route — handles magic-link ?token= and authenticated user view
  {
    path: ["/me", "/profile"],
    exact: true,
    component: "Profile",
    noLayout: true,
  },
  // 404 catch-all route (must be last)
  {
    path: "*",
    exact: false,
    component: "NotFound",
  },
];

export default routes;
